// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__TWkXk","l3":"Spinner_l3__H4BdX"};